
import React, { ReactNode, useState } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { AuthenticatedHeader } from "./AuthenticatedHeader";
import { LandingHeader } from "./LandingHeader";
import { useLocation } from "react-router-dom";
import { useAuthState } from "@/hooks/useAuthState";

interface MainLayoutProps {
  children?: ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  const location = useLocation();
  const { isAuthenticated, userName } = useAuthState();
  const [showHistory, setShowHistory] = useState(false);

  // Determine if this is a landing page route
  const isLandingPage =
    location.pathname === "/" ||
    location.pathname === "/pricing" ||
    location.pathname === "/faq" ||
    location.pathname === "/support";

  return (
    <div className="flex flex-col min-h-screen bg-background">
      {isLandingPage || !isAuthenticated ? (
        <LandingHeader />
      ) : (
        <AuthenticatedHeader userName={userName} showHistory={showHistory} />
      )}
      <main className="flex-1">
        {children || <Outlet />}
      </main>
      <Toaster />
    </div>
  );
};
